<template>
    <div id="pagos-header">
        <div id="sig-container" class="full form-horizontal">
                <div class="widget">
                    <div class="row">
                    <div class="col">
                        <div class="widget">
                            <div class="widget-content widget-content-mini themed-background-dark-default text-light">
                                <span class="float-right text-muted">
                                    <i class="fa fa-pie-chart"></i>
                                </span>
                                Cumplimiento de presupuesto por asesores del mes en curso
                            </div>
                            <div class="widget-content border-bottom themed-background-muted text-center">
                                <bar-chart :grafica="'presupuestos'"/>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
        </div>
    </div>


</template>
<script>
    import {mapGetters} from 'vuex'
    
    export default {
        data () {
            return {

            }
        },
        components: {
            BarChart: () => import('@/components/chart/BarChart')
        },
        computed: {
            ...mapGetters({'loading': 'presupuesto/loading'}),
        },
        methods: {
            
        },
        mounted() {

        }
    }
</script>
<style>
 .disponibles {
    display: flow-root !important;
 }
 .titulos-disponible {
    padding-left: initial !important;
    padding-right: initial !important;
 }
    .muted-color {
        color: #b9b9b9;
        font-style: italic;
    }

    .centrar {
        display: block;
    }
</style>
